import { useEffect, useState } from "react";
import { BASE_URL } from "../config";
import { formatAppDate, formatAppDateTime, formatAppTime } from "../utils/appDateTime";

export default function TimesheetPrint() {
	const [rows, setRows] = useState([]);

	useEffect(() => {
		(async () => {
			try {
				const res = await fetch(`${BASE_URL}/api/admin/timesheets`);
				const json = await res.json();
				setRows(json.data || []);
			} catch (e) {
				console.error(e);
			}
		})();
	}, []);

	// group by staffId
	const byStaff = rows.reduce((acc, r) => {
		acc[r.staffId] = acc[r.staffId] || { staff: r.staffName, items: [] };
		acc[r.staffId].items.push(r);
		return acc;
	}, {});

	return (
		<div className="p-6 print:p-0">
			{Object.entries(byStaff).map(([staffId, group], idx) => (
				<div key={staffId} className="mb-10 print:break-after-page">
					<div className="flex items-center justify-between mb-4">
						<h2 className="text-lg font-semibold">{group.staff} (ID #{staffId})</h2>
						<div className="text-sm text-slate-500">Pay Period: —</div>
					</div>
					<table className="w-full text-xs border">
						<thead className="bg-gray-50">
							<tr>
								<th className="px-2 py-1 text-left">Date</th>
								<th className="px-2 py-1 text-left">Client</th>
								<th className="px-2 py-1 text-left">Location</th>
								<th className="px-2 py-1 text-left">Position</th>
								<th className="px-2 py-1 text-left">Scheduled</th>
								<th className="px-2 py-1 text-left">Actual</th>
								<th className="px-2 py-1 text-left">Regular</th>
								<th className="px-2 py-1 text-left">OT</th>
								<th className="px-2 py-1 text-left">Travel</th>
								<th className="px-2 py-1 text-left">Adj.</th>
								<th className="px-2 py-1 text-left">Notes</th>
							</tr>
						</thead>
						<tbody>
							{group.items.map((r, i) => (
								<tr key={i} className="border-t">
									<td className="px-2 py-1">{formatAppDate(r.scheduledStart)}</td>
									<td className="px-2 py-1">{r.client}</td>
									<td className="px-2 py-1">{r.location}</td>
									<td className="px-2 py-1">{r.position}</td>
									<td className="px-2 py-1">{formatAppTime(r.scheduledStart)} – {formatAppTime(r.scheduledEnd)}</td>
									<td className="px-2 py-1">{formatAppTime(r.actualStart)} – {formatAppTime(r.actualEnd)}</td>
									<td className="px-2 py-1">{r.regular_hours || "—"}</td>
									<td className="px-2 py-1">{r.overtime_hours || "—"}</td>
									<td className="px-2 py-1">{r.travelTime ?? "—"}</td>
									<td className="px-2 py-1">{r.adjustments ?? "—"}</td>
									<td className="px-2 py-1">{r.notes || ""}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			))}
		</div>
	);
}



